module.exports = __webpack_public_path__ + "static/media/water_500_detail_01.3b63678f.jpg";